export default __webpack_public_path__ + "static/media/4.16665a30.png";